<template>
<v-row>
    <v-col cols="1"></v-col>
    <v-col cols="10">
        <v-card-text class="">
            <h2 class="indigo--text text--darken-4"><u>Compétences</u></h2>
            <br>
            <v-row>
                <v-col cols="4" v-for="(type, index) in items" :key="'col-'+index">
                    <v-card color="blue-grey lighten-5" class="fill-height">
                        <v-card-title class="justify-center blue-grey--text text--darken-3">{{ type.label }}</v-card-title>
                        <ul class="fa-ul ml-0 pl-0">
                            <li v-for="(item, i) in type.list" :key="type.label+'-'+i">
                                <span class="blue--text text--darken-4">
                                    <strong v-html="item.label"></strong>
                                </span>
                                <v-rating length="5" empty-icon="far fa-star" full-icon="fas fa-star" half-icon="fas fa-star-half-alt" half-increments
                                    color="blue darken-4" :value="(item.level/20)">
                                </v-rating>
                            </li>
                        </ul>
                    </v-card>
                </v-col>
            </v-row>
        </v-card-text>
    </v-col>
    <v-col cols="1"></v-col>
</v-row>
</template>

<script>
export default {
    name: 'Skills',
    data: () => ({
        items: [
        {
            label: 'Langages',
            list:
            [
                { label: 'PHP', level: 100 }, 
                { label: 'Javascript', level: 80 },
                { label: 'Shell - Bash', level: 90 }, 
                { label: 'Python', level: 70 },
                { label: 'VisualBasic 6', level: 80 }, 
                { label: 'JavaEE', level: 40 },
            ],
        },
        {
            label: 'Frameworks',
            list:
            [
                { label: 'Symfony <small>(PHP)</small>', level: 60 }, 
                { label: 'Laravel <small>(PHP)</small>', level: 80 },
                { label: 'Bootstrap <small>(CSS)</small>', level: 80 }, 
                { label: 'Bulma <small>(CSS)</small>', level: 60 },
                { label: 'Vuetify <small>(CSS)</small>', level: 70 },
                { label: 'VueJS <small>(JavaScript)</small>', level: 70 }, 
                { label: 'AngularJS <small>(Javascript)</small>', level: 60 },
                { label: 'JQuery <small>(JavaScript)</small>', level: 90 }
            ],
        },
        {
            label: 'Bases de données',
            list:
            [
                { label: 'MySQL', level: 90 }, 
                { label: 'SQL Server', level: 70 }, 
                { label: 'Oracle', level: 50 }, 
                { name: 'db2', label: 'DB2', level: 70 },
                { name: 'mongodb', label: 'MongoDB', level: 40 },
            ]
        }]
    }),
}
</script>
